// store/store.ts
import { create } from "zustand";
import { AuthSlice, createAuthSlice } from "./slices/auth/auth-slice";
import { combineSlices } from "./slices/combineSlices";
import { ChatSlice, createChatSlice } from "./slices/chat/chat-slice";

export type StoreState = AuthSlice & ChatSlice;

export const useStore = create<StoreState>()(
  combineSlices<StoreState>()(createAuthSlice, createChatSlice)
);
export const getStoreState = () => useStore.getState();
